import { Link } from "react-router-dom";

const HeroBannerComp = ({ image, title, ctaLabel, ctaTo, className }) => {
  const isExternal = /^https?:/.test(ctaTo || "");
  return (
    <div className={`herobanner__comp ${className || ""}`}>
      <img src={image} alt={title} className="hero-img" />
      {ctaTo && (
        <div className="hero-overlay">
          {isExternal ? (
            <a href={ctaTo} className="btn-join" target="_blank" rel="noopener noreferrer">
              {ctaLabel}
            </a>
          ) : (
            <Link to={ctaTo} className="btn-join">
              {ctaLabel}
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroBannerComp;
